import { Annotation, PlottableModel } from '../4d-objects';
import { LegacyAnnotationRenderer } from './cesium-renderers-annot';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import {  Renderer,PlottableReference } from '../renderer'
const Cesium = (<any>window).Cesium

/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
export class PinAnnotationRenderer extends LegacyAnnotationRenderer{


  onUpdate(obj: Annotation, pr: PlottableReference, args?: any):Observable<PlottableReference> {
    return super.onUpdate(obj,pr,args).pipe(tap(res => res.object.pin.billboard.image = this.getPinImage(res.plottable)))
  }
  


   /*
        Static pin helpers 
    */

  getPinImage ( annotation: PlottableModel<any>, pinColor?: string ) {
    if (!annotation) return;

    return this.getPinSvg ( annotation['icon'] || 'map-marker-alt', pinColor ? pinColor : annotation['color'] || 'blue' );
  }

  getPinSvg ( icon:string, pinColor:string = 'red', size:number = 45 ) {
    switch (icon) {
      case 'flag':
        return 'data:image/svg+xml;base64,' + window['btoa'](
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="flag" class="svg-inline--fa fa-flag fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" height="'+size+'" width="'+size+'" viewBox="0 0 512 512">' +
          '<path fill="' + pinColor + '" d="M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"></path></svg>');
      case 'exclamation-triangle':
        return 'data:image/svg+xml;base64,' + window['btoa'](
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" class="svg-inline--fa fa-exclamation-triangle fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" height="'+size+'" width="'+size+'" viewBox="0 0 576 512">' +
          '<path fill="' + pinColor + '" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg>');
      default:
        return 'data:image/svg+xml;base64,' + window['btoa'](
          '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="map-marker-alt" class="svg-inline--fa fa-map-marker-alt fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg"  height="'+size+'" width="'+size+'" viewBox="0 0 384 512">' +
          '<path fill="' + pinColor + '" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>');
    }
  }

}
